import script from "./WageTaxRes.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageTaxRes.vue?vue&type=script&setup=true&lang=ts"

import "./WageTaxRes.vue?vue&type=style&index=0&id=f9f45a36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9f45a36"]])

export default __exports__